import { render } from "./DeleteSubCategoryDialog.vue?vue&type=template&id=473f0ac4"
import script from "./DeleteSubCategoryDialog.vue?vue&type=script&lang=js"
export * from "./DeleteSubCategoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__